export default __webpack_public_path__ + "static/media/logo9.06358829.svg";